/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const VehicleType = {
	Other: 'Other',
	Car: 'Car',
	Truck: 'Truck',
	Lorry: 'Lorry',
	Trailer: 'Trailer',
	Motorbike: 'Motorbike',
} as const;
export type VehicleType = (typeof VehicleType)[keyof typeof VehicleType];

export function instanceOfVehicleType(value: any): boolean {
	for (const key in VehicleType) {
		if (Object.prototype.hasOwnProperty.call(VehicleType, key)) {
			if (VehicleType[key as keyof typeof VehicleType] === value) {
				return true;
			}
		}
	}
	return false;
}

export function VehicleTypeFromJSON(json: any): VehicleType {
	return VehicleTypeFromJSONTyped(json, false);
}

export function VehicleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleType {
	return json as VehicleType;
}

export function VehicleTypeToJSON(value?: VehicleType | null): any {
	return value as any;
}

export function VehicleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): VehicleType {
	return value as VehicleType;
}
